import AppRoutes from "./Routing/AppRoutes";

function App() {
  return <AppRoutes />;
}

export default App;
